<div class="progress-bar" [class.theme-white]="theme === 'white'" data-testid="MoviePlayerPage.progressBar">
  <div class="progress" [style.width]="progressInPercentage + '%'"></div>
</div>
<p *ngIf="showProgressMinutes" class="progress-minutes" data-testid="MovieDetailsPage.progressMinutes">
  {{ 'Progress_Bar_Remaining' | translate: { minutes: remainingMinutes } }}
</p>
